module.exports = __webpack_public_path__ + "static/media/18.9e2653d6.svg";